var _rect, _rect2, _rect3, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpand(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 14,
    rx: 2,
    transform: "matrix(-1 0 0 1 16 5)",
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 14,
    rx: 2,
    transform: "matrix(-1 0 0 1 16 5)",
    fill: "black",
    fillOpacity: 0.2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 14,
    rx: 2,
    transform: "matrix(-1 0 0 1 16 5)",
    fill: "black",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9999 2.39844C19.9881 2.39844 21.5999 4.01021 21.5999 5.99844V17.9984C21.5999 19.9867 19.9881 21.5984 17.9999 21.5984H5.9999C4.01168 21.5984 2.3999 19.9867 2.3999 17.9984L2.3999 5.99844C2.3999 4.01021 4.01168 2.39844 5.9999 2.39844L17.9999 2.39844Z",
    stroke: "black",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/Expand.814b85734a924d405ad84505a2b38d44.svg";
export { ForwardRef as ReactComponent };